import React,{useState,useEffect} from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import Select,{SelectChangeEvent} from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import Hidden from '@mui/material/Hidden';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import BottomButtons from './BottomButtons';
import {Tools} from './Tools';
import {Inc,Item,Owner,Dataset,TakebackState} from './Inc';
import useStyles from './Styles';
import ColInput from './ColInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {Theme} from './Theme';

interface TakebackInputProps {
	isOpen:boolean,
    items:Item[],
    owner:Owner,
    inputs:TakebackState,
    next(states:TakebackState):void,
    close(): void,
}

const TakebackInput = (props:TakebackInputProps)=> {
    const classes = useStyles();
	const fullScreen = useMediaQuery(Theme.breakpoints.down('sm'));
    const defStates:TakebackState = {
        how_id: "1",
        values: new Array<number>(props.items.length).fill(1),
        samples: new Array<string>(props.items.length).fill("0"),
        message: "",
		hasSample: false,
		hasError: false,
    }
    const [states,setStates] = useState(defStates);
    const change = (name:keyof TakebackState,value:string)=>{
        setStates({...states,[name]:value});
    }
    const changeValue = (index:number)=>(event: React.ChangeEvent<HTMLInputElement>) => {
        let vs = states.values.concat();
        let v = Tools.toHan(event.target.value);
        if( v==="" ){
            vs[index] = 0;
        } else {
            let vp = parseInt(v);
            //if( vp<0 ){
            //    vp = 0;
            //}
            vs[index] = vp;
        }
        validate({...states,"values":vs});
    }
	const changeSample = (index: number) => (event: SelectChangeEvent) => {
        let vs = states.samples.concat();
        let v = "0";
        if( event.target.value==="1" ){
            v = "1";
        }
        if( event.target.value==="2" ){
            v = "2";
        }
        vs[index] = v;
        validate({...states,"samples":vs});
    };

    const validate = (data:TakebackState)=>{
		let num = 0;
		let error = false;
		for( let i=0; i<props.items.length; i++ ){
			if( data.values[i]>0 || data.samples[i]==='1' ){
				num++;
			}
			if( props.items[i].num_stock<data.values[i] ){
				error = true;
			}
		};
		if( num===0 ){
			error = true;
		}
		setStates({...data,hasError:error});
	}

	const send = ()=>{
        let values = states.values.concat();
		for( let i=0; i<props.items.length; i++ ){
			if( props.items[i].num_stock<values[i] ){
				values[i] = props.items[i].num_stock;
			}
		};
		props.next({...states,values:values});
    }

	useEffect(()=>{
		if(props.isOpen){
			if( props.inputs.how_id!=="" ){
				setStates({...props.inputs});
			} else {
				const values = new Array<number>(props.items.length).fill(1);
				const samples = new Array<string>(props.items.length).fill("0");
				let hasSample = false;
				for( let i=0; i<props.items.length; i++ ){
					values[i] = props.items[i].num_stock;
					if( props.items[i].sample_flag==='1' ){
						samples[i] = "1";
						hasSample = true;
					}
				};
				setStates({...defStates,values:values,samples:samples,hasSample:hasSample});
			}
			//if( props.inputs.how_id!=="" ){
			//	defStates = props.inputs;
			//}
		
		}
	},[props.isOpen])

	if(!props.isOpen){
		return (null);
	}

	return (
		<Dialog
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={true}
			onClose={(event: object, reason: string) =>{
				if( reason!=="backdropClick" ){
					props.close();
				}
			}}
			maxWidth='md'
			fullScreen={fullScreen}
		>
			<DialogTitle color="primary">商品引取</DialogTitle>
			<DialogContent dividers>
				<div className={classes.confirmGuide}>
				ご希望の引き取り方法を選択して、「確認する」を押して下さい。 <br/>
				<ul className={classes.hintUl}>
					<li className={classes.hintLi}>※在庫の一部だけを引き取りたい場合は個数欄を適宜修正して下さい。</li>
					<li className={classes.hintLi}>※受付完了後1営業日程度で、送料や発送日をメールでお知らせいたします。</li>
					<li className={classes.hintLi}>※「なるべく安く」は、ゆうパケットで送れるサイズ（長辺34cm以内、厚さ3cm以内、重さ1kg以内）かつ売上残高から送料を差し引ける場合にゆうパケットで、それ以外はゆうパックでお届けします。</li>
					<li className={classes.hintLi}>※ゆうパック、ゆうパケット、クリックポスト以外の配送手段（クロネコヤマト、佐川急便など）は指定できません。</li>
					<li className={classes.hintLi}>※特別なご要望がある場合は「その他」を選択して下さい。（ご購入いただいた商品に同梱するなど）</li>
					<li className={classes.hintLi}>※井の頭倉庫でのお渡しの場合は送料はかかりません。</li>
				</ul>
			
				</div>
				<div style={{marginBottom:"2em"}}>
					<Grid container spacing={2}>
						<Grid item xs={12}>
							<ColInput name="引き取り方法" value={states.how_id} change={change} id="how_id" type="radio" list={Inc.takebackHows} required/>
						</Grid>
						<Grid item xs={12}>
							<ColInput name="メッセージ（省略可）" value={states.message} change={change} id="message" type="textarea"/>
						</Grid>
					</Grid>

					<FormLabel component="label">引き取る商品</FormLabel>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell className={classes.tableHeadNowrap} align='center'>商品</TableCell>
								<TableCell className={classes.tableHeadNowrap} align='center'>在庫</TableCell>
								<TableCell className={classes.tableHeadNowrap} align='center'>引取数</TableCell>
								{states.hasSample &&
								<TableCell className={classes.tableHeadNowrap} align='center'>見本</TableCell>
								}
							</TableRow>
						</TableHead>
						<TableBody>
					{props.items.map( (item:Item,index:number)=>{
						const key = "item"+index;
						return (
							<TableRow key={key}>
								<TableCell className={classes.tableCellDense}>
									<span className={classes.itemId}>ID:{item.item_id}</span>　
									<Hidden smUp implementation="js">
										<br/>
									</Hidden>
									{item.item_name}
								</TableCell>
								<TableCell className={classes.tableCellNowrap} align="right">{item.num_stock}</TableCell>
								<TableCell align="right">
									<input type="text" className={classes.input} style={{width:"4em",marginRight:"0.5em"}} onChange={changeValue(index)} value={states.values[index]}/>
								</TableCell>
								{states.hasSample &&
								<TableCell className={classes.tableCellNowrap} align='center'>
									{item.sample_flag==='1' ? (
									<Select
										value={states.samples[index]}
										onChange={changeSample(index)}
										margin="none"
										variant="standard"
										style={{marginTop:"0.3em",fontSize:'90%'}}
									>
										{Inc.withSamples && 
											Inc.withSamples.map((option:Dataset,index:number) => {
												const key = "option"+index;
												return (
													<MenuItem key={key} value={option.id}>
														{option.label}
													</MenuItem>
												)
											})
										}
									</Select>
									):(
										<span className="emptyText">なし</span>
									)}
								</TableCell>
								}
							</TableRow>
						);
					})}
						</TableBody>
					</Table>
				</div>
				<div style={{fontSize:"90%",padding:"1em",border:"1px solid silver"}}>
					<div className={classes.primary}><FontAwesomeIcon icon="truck"/> 売上残高は十分ですか？</div>
					送料は売上残高から差し引きます。引き取りと同時に支払申請をしたい場合は、まずは引き取りの手続きだけを行い、商品がお手元に届いてから支払申請を行って下さい。<br/>
					なお、残高が足りない場合は着払い（ゆうパック）でのお届けとなります。<br/>
				</div>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<BottomButtons button1='確認する' onClick1={send} disabled1={states.hasError} button2='選びなおす' onClick2={props.close} top={0} bottom={0}/>
			</DialogActions>
        </Dialog>
	);
}

export default TakebackInput;
